"use strict";

/*==============================================================================
TRESTLE™ W002
CREATE / EDIT MY TRESTLE PROFILE

Brand        : Diafemme®
Module       : W002
File         : TRESTLE_W002_Create.js
Version      : 4.0

Responsibilities
----------------
• Create TRESTLE profile
• Edit existing TRESTLE profile
• Restore saved profile
• Update incomplete / complete header state
• Preserve Promise / Life Stage / Diabetes Profile architecture
• Preserve downstream profile events
==============================================================================*/


const W002={


/*==============================================================================
STATE
==============================================================================*/

state:{

    currentScreen:0,

    totalScreens:3,

    profileComplete:false

},


/*==============================================================================
DOM
==============================================================================*/

ui:{

    root:null,

    accordion:null,

    toggle:null,

    icon:null,

    badge:null,

    status:null,

    title:null,

    intro:null,

    actionPrompt:null,

    actionText:null,

    openLabel:null,

    image:null,

    back:null,

    next:null,

    save:null,

    loader:null,

    error:null,

    dots:[],

    screens:[]

},


/*==============================================================================
INIT
==============================================================================*/

init(){

    this.cacheDOM();


    if(
        !this.ui.root ||
        !this.ui.toggle ||
        !this.ui.accordion
    ){

        return;

    }


    this.bindEvents();

    this.reset();

    this.restoreSavedProfile();


    console.log(
        "W002 Ready"
    );

},


/*==============================================================================
RESET
==============================================================================*/

reset(){

    this.state.currentScreen=0;

    this.updateScreen();

},


/*==============================================================================
CACHE DOM
==============================================================================*/

cacheDOM(){

    this.ui.root=

        document.getElementById(
            "trW002"
        );


    this.ui.accordion=

        document.getElementById(
            "trAccordion"
        );


    this.ui.toggle=

        document.getElementById(
            "trAccordionToggle"
        );


    this.ui.icon=

        document.getElementById(
            "trAccordionIcon"
        );


    this.ui.badge=

        document.getElementById(
            "trPromiseBadge"
        );


    this.ui.status=

        document.getElementById(
            "trProfileStatus"
        );


    this.ui.title=

        document.getElementById(
            "trW002Title"
        );


    this.ui.intro=

        document.getElementById(
            "trW002Intro"
        );


    this.ui.actionPrompt=

        document.getElementById(
            "trW002ActionPrompt"
        );


    this.ui.actionText=

        this.ui.actionPrompt
        ?
        this.ui.actionPrompt.querySelector(
            ".tr-w002-action-text"
        )
        :
        null;


    this.ui.openLabel=

        document.getElementById(
            "trW002OpenLabel"
        );


    this.ui.image=

        document.getElementById(
            "trChapterImage"
        );


    this.ui.back=

        document.getElementById(
            "trBack"
        );


    this.ui.next=

        document.getElementById(
            "trContinue"
        );


    this.ui.save=

        document.getElementById(
            "trSave"
        );


    this.ui.loader=

        document.getElementById(
            "trLoader"
        );


    this.ui.error=

        document.getElementById(
            "trError"
        );


    this.ui.dots=[

        ...document.querySelectorAll(
            "#trProgressDots span"
        )

    ];


    this.ui.screens=[

        document.getElementById(
            "trPromiseScreen"
        ),

        document.getElementById(
            "trLifeStageScreen"
        ),

        document.getElementById(
            "trDiabetesScreen"
        )

    ];

},


/*==============================================================================
BIND EVENTS
==============================================================================*/

bindEvents(){

    this.ui.toggle.addEventListener(

        "click",

        ()=>{

            this.toggleAccordion();

        }

    );


    this.ui.next.addEventListener(

        "click",

        ()=>{

            this.nextScreen();

        }

    );


    this.ui.back.addEventListener(

        "click",

        ()=>{

            this.previousScreen();

        }

    );


    this.ui.save.addEventListener(

        "click",

        ()=>{

            this.saveProfile();

        }

    );

},


/*==============================================================================
TOGGLE ACCORDION
==============================================================================*/

toggleAccordion(){

    if(
        this.ui.accordion.hidden
    ){

        this.openAccordion();

    }

    else{

        this.closeAccordion();

    }

},


/*==============================================================================
OPEN ACCORDION
==============================================================================*/

openAccordion(){

    this.ui.accordion.hidden=false;

    this.ui.icon.textContent="−";


    this.ui.toggle.setAttribute(
        "aria-expanded",
        "true"
    );

},


/*==============================================================================
CLOSE ACCORDION
==============================================================================*/

closeAccordion(){

    this.ui.accordion.hidden=true;

    this.ui.icon.textContent="+";


    this.ui.toggle.setAttribute(
        "aria-expanded",
        "false"
    );

},


/*==============================================================================
UPDATE SCREEN
==============================================================================*/

updateScreen(){

    this.ui.screens.forEach(

        (screen,index)=>{

            if(!screen){
                return;
            }


            screen.classList.remove(
                "active"
            );


            if(
                index===
                this.state.currentScreen
            ){

                screen.classList.add(
                    "active"
                );

            }

        }

    );


    this.updateButtons();

    this.updateDots();

},


/*==============================================================================
UPDATE BUTTONS
==============================================================================*/

updateButtons(){

    this.ui.back.disabled=

        this.state.currentScreen===0;


    if(
        this.state.currentScreen===
        this.state.totalScreens-1
    ){

        this.ui.next.hidden=true;

        this.ui.save.hidden=false;

    }

    else{

        this.ui.next.hidden=false;

        this.ui.save.hidden=true;

    }

},


/*==============================================================================
UPDATE DOTS
==============================================================================*/

updateDots(){

    this.ui.dots.forEach(

        (dot,index)=>{

            dot.classList.remove(
                "active"
            );


            if(
                index===
                this.state.currentScreen
            ){

                dot.classList.add(
                    "active"
                );

            }

        }

    );

},


/*==============================================================================
NEXT SCREEN
==============================================================================*/

nextScreen(){

    if(
        !this.validateCurrentScreen()
    ){

        return;

    }


    if(
        this.state.currentScreen<
        this.state.totalScreens-1
    ){

        this.state.currentScreen++;

        this.updateScreen();

    }

},


/*==============================================================================
PREVIOUS SCREEN
==============================================================================*/

previousScreen(){

    if(
        this.state.currentScreen>0
    ){

        this.state.currentScreen--;

        this.updateScreen();

    }

},


/*==============================================================================
GET PROMISE
==============================================================================*/

getPromise(){

    const selected=

        document.querySelector(
            'input[name="priorityTitle"]:checked'
        );


    return selected
        ?
        selected.value
        :
        "";

},


/*==============================================================================
GET LIFE STAGE
==============================================================================*/

getLifeStage(){

    const selected=

        document.querySelector(
            'input[name="lifeStage"]:checked'
        );


    return selected
        ?
        selected.value
        :
        "";

},


/*==============================================================================
GET DIABETES TYPE
==============================================================================*/

getDiabetesType(){

    const selected=

        document.querySelector(
            'input[name="diabetesType"]:checked'
        );


    return selected
        ?
        selected.value
        :
        "";

},


/*==============================================================================
PROFILE COMPLETENESS
==============================================================================*/

isProfileComplete(profile){

    return Boolean(

        profile &&
        profile.promise &&
        profile.lifeStage &&
        profile.diabetesType

    );

},


/*==============================================================================
SHOW ERROR
==============================================================================*/

showError(message){

    this.ui.error.textContent=
        message;


    this.ui.error.hidden=false;

},


/*==============================================================================
CLEAR ERROR
==============================================================================*/

clearError(){

    this.ui.error.hidden=true;

    this.ui.error.textContent="";

},


/*==============================================================================
VALIDATE CURRENT SCREEN
==============================================================================*/

validateCurrentScreen(){

    this.clearError();


    switch(
        this.state.currentScreen
    ){


        case 0:

            if(
                !this.getPromise()
            ){

                this.showError(
                    "Please select today's promise."
                );

                return false;

            }

            break;


        case 1:

            if(
                !this.getLifeStage()
            ){

                this.showError(
                    "Please select your life stage."
                );

                return false;

            }

            break;


        case 2:

            if(
                !this.getDiabetesType()
            ){

                this.showError(
                    "Please select your diabetes profile."
                );

                return false;

            }

            break;

    }


    return true;

},


/*==============================================================================
AFFIRMATIONS
==============================================================================*/

affirmations:{

    "More Calmness":
        "Today I Promise myself, more calmness.",

    "More Energy":
        "Today I Promise myself, more energy.",

    "Better Focus":
        "Today I Promise myself, better focus.",

    "Healthier Living":
        "Today I Promise myself, healthier living.",

    "Better Sleep":
        "Today I Promise myself, better sleep.",

    "Balanced Life":
        "Today I Promise myself, a more balanced life."

},


/*==============================================================================
BUILD PROFILE
==============================================================================*/

buildProfile(){

    const promise=
        this.getPromise();


    return{

        promise:promise,

        affirmation:
            this.affirmations[
                promise
            ],

        lifeStage:
            this.getLifeStage(),

        diabetesType:
            this.getDiabetesType(),

        updatedAt:
            new Date()
            .toISOString()

    };

},


/*==============================================================================
SAVE PROFILE
==============================================================================*/

saveProfile(){

    if(
        !this.validateCurrentScreen()
    ){

        return;

    }


    const profile=
        this.buildProfile();


    localStorage.setItem(

        "trestleProfile",

        JSON.stringify(
            profile
        )

    );


    window.dispatchEvent(

        new CustomEvent(
            "trestle-profile-updated"
        )

    );


    this.updateHeader(
        profile
    );


    this.broadcastProfile(
        profile
    );


    this.closeAccordion();


    console.log(
        "TRESTLE Profile Saved",
        profile
    );

},


/*==============================================================================
LOAD PROFILE
==============================================================================*/

loadProfile(){

    try{

        const stored=

            localStorage.getItem(
                "trestleProfile"
            );


        if(!stored){

            return null;

        }


        return JSON.parse(
            stored
        );

    }

    catch(error){

        console.warn(
            "W002: Unable to load saved profile",
            error
        );


        return null;

    }

},


/*==============================================================================
RESTORE SAVED PROFILE
==============================================================================*/

restoreSavedProfile(){

    const profile=
        this.loadProfile();


    if(
        !profile
    ){

        this.setIncompleteHeader();

        return;

    }


    this.restoreRadioValue(
        "priorityTitle",
        profile.promise
    );


    this.restoreRadioValue(
        "lifeStage",
        profile.lifeStage
    );


    this.restoreRadioValue(
        "diabetesType",
        profile.diabetesType
    );


    this.updateHeader(
        profile
    );

},


/*==============================================================================
RESTORE RADIO VALUE
==============================================================================*/

restoreRadioValue(
    name,
    value
){

    if(!value){
        return;
    }


    const inputs=

        document.querySelectorAll(
            `input[name="${name}"]`
        );


    inputs.forEach(input=>{

        input.checked=
            input.value===value;

    });

},


/*==============================================================================
UPDATE HEADER
==============================================================================*/

updateHeader(profile){

    if(
        this.isProfileComplete(
            profile
        )
    ){

        this.setCompleteHeader(
            profile
        );

    }

    else{

        this.setIncompleteHeader();

    }

},


/*==============================================================================
INCOMPLETE HEADER
==============================================================================*/

setIncompleteHeader(){

    this.state.profileComplete=false;


    this.ui.root.classList.remove(
        "tr-w002-profile-complete"
    );


    if(this.ui.title){

        this.ui.title.textContent=
            "Create My TRESTLE Profile";

    }


    if(this.ui.intro){

        this.ui.intro.textContent=
            "3 quick choices help TRESTLE personalize your experience.";

    }


    if(this.ui.actionText){

        this.ui.actionText.textContent=
            "Create / Edit My TRESTLE Profile";

    }


    if(this.ui.openLabel){

        this.ui.openLabel.textContent=
            "Click here";

    }


    if(this.ui.badge){

        this.ui.badge.textContent=
            "Today's Promise: Not Selected";

    }


    if(this.ui.status){

        this.ui.status.textContent=
            "Profile 0 / 3";

    }

},


/*==============================================================================
COMPLETE HEADER
==============================================================================*/

setCompleteHeader(profile){

    this.state.profileComplete=true;


    this.ui.root.classList.add(
        "tr-w002-profile-complete"
    );


    if(this.ui.title){

        this.ui.title.textContent=
            "My TRESTLE Profile";

    }


    if(this.ui.intro){

        this.ui.intro.textContent=
            "Your profile is ready. Update it whenever something changes.";

    }


    if(this.ui.actionText){

        this.ui.actionText.textContent=
            "View / Edit My TRESTLE Profile";

    }


    if(this.ui.openLabel){

        this.ui.openLabel.textContent=
            "View / Edit";

    }


    if(this.ui.badge){

        this.ui.badge.textContent=
            "Today's Promise: " +
            profile.promise;

    }


    if(this.ui.status){

        this.ui.status.textContent=
            "Profile 3 / 3 ✓";

    }

},


/*==============================================================================
BROADCAST PROFILE
==============================================================================*/

broadcastProfile(profile){

    document.dispatchEvent(

        new CustomEvent(

            "trestle:profile-updated",

            {
                detail:profile
            }

        )

    );

},


/*==============================================================================
PUBLIC API
==============================================================================*/

getProfile(){

    return this.loadProfile();

},


open(){

    this.openAccordion();

},


close(){

    this.closeAccordion();

}


/*==============================================================================
END W002
==============================================================================*/

};


/*==============================================================================
BOOTSTRAP
==============================================================================*/

document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        W002.init();

    }

);